import { useCallback, useEffect } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";

import { SkeletonPageWrapper } from "components/skeletons/SkeletonPageWrapper";
import { useLinksRouteRequests } from "../hooks/useLinksRouteRequests";

export default function Links() {
	const { isLoading, error, redirectWebUrlFromLink } = useLinksRouteRequests();
	const navigate = useNavigate();
	const { appAlias } = useParams<"appAlias">();

	const resolveLink = useCallback(() => {
		navigate(
			{
				pathname: redirectWebUrlFromLink.pathname,
				search: redirectWebUrlFromLink.search,
			},
			{ replace: true }, // We don't want the links url in the history stack
		);
	}, [navigate, redirectWebUrlFromLink.pathname, redirectWebUrlFromLink.search]);

	useEffect(() => {
		if (isLoading) return;
		if (error) return;

		resolveLink();
	}, [isLoading, error, resolveLink]);

	if (error) return <Navigate to={{ pathname: `/${appAlias}` }} />;
	return <SkeletonPageWrapper />;
}
